"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var swr_1 = require("swr");
var filter_1 = tslib_1.__importDefault(require("./components/filter"));
var context_1 = tslib_1.__importDefault(require("./context"));
var fetcher_1 = require("./hooks/fetcher");
var table_1 = tslib_1.__importDefault(require("./table"));
var types_1 = require("./types");
var locale_1 = tslib_1.__importDefault(require("./locale"));
var data_grid_1 = tslib_1.__importDefault(require("./data-grid"));
var search_1 = tslib_1.__importDefault(require("./hooks/search"));
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var updateLocale_1 = tslib_1.__importDefault(require("dayjs/plugin/updateLocale"));
var StyledSpace = (0, styled_components_1.default)(antd_1.Space)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var Table = function (_a) {
    var id = _a.id, columns = _a.columns, filters = _a.filters, url = _a.url, httpClientGet = _a.httpClientGet, callback = _a.callback, mutateTable = _a.mutateTable, limit = _a.limit, modifier = _a.modifier, defaultSort = _a.defaultSort, onRow = _a.onRow, onDelete = _a.onDelete, onEdit = _a.onEdit, onView = _a.onView, quickFilters = _a.quickFilters, router = _a.router, lang = _a.lang, sortable = _a.sortable, getKey = _a.getKey, style = _a.style, fetcherProps = _a.fetcherProps, offsetTop = _a.offsetTop, tabsFilter = _a.tabsFilter, searchText = _a.searchText, controls = _a.controls, defaultLayout = _a.defaultLayout, gridRender = _a.gridRender, renderItemWidth = _a.renderItemWidth, empty = _a.empty, antdLocale = _a.antdLocale, onStateChange = _a.onStateChange, tokens = _a.tokens, defaultColumWidth = _a.defaultColumWidth;
    var _b = (0, react_1.useState)("table"), view = _b[0], setView = _b[1];
    //TODO: move outside table this way router and http client can be defined in caller.
    var _c = (0, fetcher_1.useTableFetcher)(url, defaultSort, httpClientGet, getKey, limit, router, fetcherProps, empty === null || empty === void 0 ? void 0 : empty.onHasFilter, filters), loading = _c.loading, data = _c.data, count = _c.count, hasMore = _c.hasMore, handler = _c.handler, mutate = _c.mutate, hasFilter = _c.hasFilter;
    (0, search_1.default)(handler.removeFilter, handler.search, searchText);
    var cache = (0, swr_1.useSWRConfig)().cache;
    (0, react_1.useEffect)(function () {
        dayjs_1.default.extend(updateLocale_1.default);
        if (lang != null) {
            dayjs_1.default.updateLocale(lang, {
                weekStart: 1,
            });
        }
        locale_1.default.setLanguage(lang || "en");
    }, [lang]);
    (0, react_1.useEffect)(function () {
        cache.delete(url);
    }, []);
    var columnsList = function () {
        if (onEdit || onDelete || onView) {
            var col = {
                title: locale_1.default.action,
                type: types_1.DATA_TYPE.CUSTOM,
                fixed: true,
                canResize: false,
                key: "action",
                isVisible: true,
                width: 100,
                dataIndex: [],
                exportable: false,
                render: function (data) { return (react_1.default.createElement(StyledSpace, null,
                    onEdit != null && (react_1.default.createElement(icons_1.EditOutlined, { onClick: function (e) {
                            onEdit(data);
                            e.stopPropagation();
                        } })),
                    onDelete != null && (react_1.default.createElement(icons_1.DeleteOutlined, { onClick: function (e) {
                            onDelete(data);
                            e.stopPropagation();
                        } })),
                    onView != null && (react_1.default.createElement(icons_1.EyeOutlined, { onClick: function (e) {
                            onView(data);
                            e.stopPropagation();
                        } })))); },
            };
            (0, lodash_1.remove)(columns, function (c) { return c.key === "action"; });
            columns.push(col);
        }
        return columns;
    };
    (0, react_1.useImperativeHandle)(mutateTable, function () { return ({
        mutate: function () {
            refreshTable();
        },
    }); });
    var refreshTable = (0, react_1.useCallback)(function () {
        mutate().then(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, antd_1.message.info("Table updated")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [mutate]);
    var records = (0, react_1.useMemo)(function () {
        if (modifier != null) {
            return modifier(data, refreshTable);
        }
        return data;
    }, [data, modifier, refreshTable]);
    var showControls = controls
        ? Object.values(controls).every(function (value) {
            return !value;
        })
        : false;
    return (react_1.default.createElement(antd_1.ConfigProvider, { locale: antdLocale, theme: {
            inherit: true,
            token: tokens,
            components: {},
        } },
        react_1.default.createElement(context_1.default, { id: id, fetchingRecordsMsg: fetcherProps.fetchingRecordsMsg, columns: columnsList(), filtersList: filters, onSearch: handler.search, onAddFilter: handler.filter, onRemoveFilter: handler.removeFilter, onMultipleSort: handler.multipleSort, defaultSort: defaultSort, onCallback: callback, sortable: sortable, style: style, setView: setView, view: defaultLayout || view },
            react_1.default.createElement(TableContainer, null,
                !showControls && (react_1.default.createElement(filter_1.default, { onStateChange: onStateChange, quickFilters: quickFilters, tabsFilter: tabsFilter, controls: controls, defaultLayout: defaultLayout, refreshTable: refreshTable, router: router, count: count })),
                (records === null || records === void 0 ? void 0 : records.length) === 0 && !loading ? (hasFilter ? (empty === null || empty === void 0 ? void 0 : empty.emptyWithFilter) : (empty === null || empty === void 0 ? void 0 : empty.emptyWithoutFilter)) : (react_1.default.createElement(react_1.default.Fragment, null, (defaultLayout || view) === "table" ? (react_1.default.createElement(table_1.default, { records: records, loading: loading, onPaginate: handler.paginate, hasMore: hasMore, onRow: onRow, offsetTop: offsetTop, emptyMessage: empty === null || empty === void 0 ? void 0 : empty.emptyWithFilter, quickFilters: !(0, lodash_1.isEmpty)(quickFilters), defaultColumWidth: defaultColumWidth })) : (react_1.default.createElement(data_grid_1.default, { records: records, loading: loading, hasMore: hasMore, onPaginate: handler.paginate, offsetTop: offsetTop, render: gridRender, renderItemWidth: renderItemWidth, quickFilters: !(0, lodash_1.isEmpty)(quickFilters) }))))))));
};
exports.Table = Table;
var TableContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  h1 {\n    font-weight: bold;\n  }\n"], ["\n  h1 {\n    font-weight: bold;\n  }\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=export.js.map